import axios from 'axios'
import { Notification, Message } from 'element-ui'
import errorCode from '@/util/errorCode'
import { getToken,  removeToken } from '@/util/auth'
import { tansParams, blobValidate } from "@/util/ruoyi";

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 100000
})


// request 请求发送器，用于携带token
service.interceptors.request.use(config => {
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  if (getToken() && !isToken) {
    config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?' + tansParams(config.params);
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }
  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})


service.interceptors.response.use(res => {
  // 未设置状态码则默认成功状态
  const code = res.data.code || 200
  // 获取错误信息
  const msg = errorCode[code] || res.data.msg || errorCode['default']
  // 二进制数据则直接返回
  if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
    return res.data
  }
  // 错误处理
  if (code === 401) {
    Notification.error({
      title: msg
    })
    return Promise.reject(msg)
  } else if (code === 500) {
    Message({
      message: msg,
      type: 'error'
    })
    return Promise.reject(msg)
  } else if (code !== 200) {
    Notification.error({
      title: msg
    })
    return Promise.reject(msg)
  } else {
    return res.data
  }
})

export default service



// WEBPACK FOOTER //
// ./src/util/request.js